import { render, staticRenderFns } from "./CountByPartner.vue?vue&type=template&id=489fa1b7&lang=pug"
import script from "./CountByPartner.vue?vue&type=script&lang=js"
export * from "./CountByPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports